/* Country Road Fashions — the product rail's arrows.

   The row scrolls on its own (overflow-x + scroll-snap in crf-rail.css);
   this only shows the two arrows when the row is wider than the screen,
   steps it one tile at a time, and hides each arrow at its end. */
(function () {
  'use strict';

  function setup(root) {
    var track = root.querySelector('[data-crf-rail-track]');
    var prev = root.querySelector('[data-crf-rail-prev]');
    var next = root.querySelector('[data-crf-rail-next]');
    if (!track || !prev || !next) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function step() {
      var tile = track.firstElementChild;
      if (!tile) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return tile.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 4;
      prev.hidden = !overflow || track.scrollLeft <= 2;
      next.hidden = !overflow || track.scrollLeft >= max - 2;
    }

    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('[data-crf-rail]').forEach(setup);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-crf-rail]').forEach(setup);
  });
}());
